/**
 * Gestion des notifications utilisateur avec Alpine.js
 */
window.notificationsData = function () {
  return {
    notifications: [],
    teamInfo: [],
    siteNotifications: [],
      unreadUserNotificationsCount: 0,
    unreadCount: 0,
    unreadTeamInfoCount: 0,
    unreadSiteNotificationsCount: 0,
    loading: true,
      statusOpen: false,
    userStatus: 'online',
    userName:  null,
    lastLogin: null,
    refreshInterval: null,
    isExpanded: false,
    notificationIsVisible: false,
    teamInfoIsVisible: false,
    siteNotificationsVisible: false,
    pushSettingsVisible: false,
      changeStatuTimeout:false,
      usersListVisible: false,
      matchesToPlayVisible: false,
      usersByStatus: {
        ready_to_play: [],
        online: [],
        in_game: []
      },
      usersWithMatches: [],
      loadingUsers: false,
      loadingMatches: false,
      liveMatches: [],
      loadingLiveMatches: false,
      liveMatchesVisible: false,
      // Popup d'invitation envoyée
      matchInvitation: {
        show: false,
        waiting: false,
        opponent: null,
        matchId: null,
        timeRemaining: 0,
        status: '',
        message: '',
        hasDelayProposal: false,
        proposedDelay: null,
        delayInfo: null
      },
      matchInvitationTimerInterval: null,
      matchInvitationCheckInterval: null,
      // Popup d'invitation reçue
      pendingMatchInvitation: {
        show: false,
        opponent: null,
        matchId: null,
        opponentClub: null,
        opponentLogo: null,
        championship: null,
        division: null,
        group: null,
        showDelayChoice: false,
        selectedDelay: 15,
        delayInfo: null
      },
      delayTimerInterval: null,
    /**
     * Initialisation du composant
     */
    initNotifications: function initNotifications() {
      let self = this;
      // Charger les notifications au démarrage
      this.fetchNotifications();

      // Configurer un rafraîchissement automatique toutes les 30 secondes
      this.refreshInterval = setInterval(function () {
        self.fetchNotifications();
      }, 30000);

      // Nettoyer l'intervalle quand le composant est détruit
      this.$cleanup = function () {
        if (self.refreshInterval) {
          clearInterval(self.refreshInterval);
        }
      };
    },
    showNotifications: function showNotifications() {
      this.isExpanded = true;
      this.notificationIsVisible = true;
      this.teamInfoIsVisible = false;
      this.siteNotificationsVisible = false;
      this.pushSettingsVisible = false;
        this.matchesToPlayVisible = false;
        if(document.querySelector('.open-sidebar-btn')){
            document.querySelector('.open-sidebar-btn').classList.add('hidden');
        }
    },

      close:function (){
          this.isExpanded = false;
          this.usersListVisible = false;
          if(document.querySelector('.open-sidebar-btn')){
              document.querySelector('.open-sidebar-btn').classList.remove('hidden');
          }
      },

    showTeamInfo: function showTeamInfo() {
      this.isExpanded = true;
      this.teamInfoIsVisible = true;
      this.notificationIsVisible = false;
      this.siteNotificationsVisible = false;
      this.pushSettingsVisible = false;
        this.matchesToPlayVisible = false;
      if(document.querySelector('.open-sidebar-btn')){
          document.querySelector('.open-sidebar-btn').classList.add('hidden');
      }
    },

    /**
     * Afficher les notifications de site
     */
    showSiteNotifications: function showSiteNotifications() {
      this.isExpanded = true;
      this.siteNotificationsVisible = true;
      this.teamInfoIsVisible = false;
      this.notificationIsVisible = false;
      this.pushSettingsVisible = false;
        this.matchesToPlayVisible = false;
        if(document.querySelector('.open-sidebar-btn')){
          document.querySelector('.open-sidebar-btn').classList.add('hidden');
      }

    },

    /**
     * Afficher les paramètres de notifications push
     */
    showPushSettings: function showPushSettings() {
      this.isExpanded = true;
      this.pushSettingsVisible = true;
      this.teamInfoIsVisible = false;
      this.notificationIsVisible = false;
      this.siteNotificationsVisible = false;
        this.matchesToPlayVisible = false;
        if(document.querySelector('.open-sidebar-btn')){
          document.querySelector('.open-sidebar-btn').classList.add('hidden');
      }
    },

    /**
     * Afficher la liste des utilisateurs par statut
     */
    openUsers: function openUsers() {
      this.isExpanded = true;
      this.usersListVisible = true;
      this.pushSettingsVisible = false;
      this.teamInfoIsVisible = false;
      this.notificationIsVisible = false;
      this.siteNotificationsVisible = false;
      if(document.querySelector('.open-sidebar-btn')){
        document.querySelector('.open-sidebar-btn').classList.add('hidden');
      }

      // Charger les utilisateurs
      this.fetchUsersByStatus();
      
      // Charger les matchs en live
      this.fetchLiveMatches();
    },

    /**
     * Récupérer les utilisateurs groupés par statut
     */
    fetchUsersByStatus: function fetchUsersByStatus() {
      let self = this;
      this.loadingUsers = true;

      fetch('/notifications/users-by-status')
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          if (data.success) {
            self.usersByStatus = data.users;

            if(data.users.with_match){
                self.usersWithMatches = data.users.with_match;
                self.matchesToPlayVisible = true;
                self.isExpanded = true;
            }

          }
          self.loadingUsers = false;
        })
        .catch(function(error) {
          console.error('Erreur lors de la récupération des utilisateurs:', error);
          self.loadingUsers = false;
        });
    },

    /**
     * Afficher la liste des matchs à jouer
     */
    openMatchesToPlay: function openMatchesToPlay() {
      this.isExpanded = true;
      this.matchesToPlayVisible = true;
      this.usersListVisible = false;
      this.pushSettingsVisible = false;
      this.teamInfoIsVisible = false;
      this.notificationIsVisible = false;
      this.siteNotificationsVisible = false;
      if(document.querySelector('.open-sidebar-btn')){
        document.querySelector('.open-sidebar-btn').classList.add('hidden');
      }

      // Charger les matchs à jouer
      this.fetchMatchesToPlay();
      
      // Charger les matchs en live
      this.fetchLiveMatches();
    },

    /**
     * Récupérer les utilisateurs avec des matchs à jouer
     */
    fetchMatchesToPlay: function fetchMatchesToPlay() {
      let self = this;
      this.loadingMatches = true;

      fetch('/notifications/users-with-matches')
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          if (data.success) {
            self.usersWithMatches = data.users;
          }
          self.loadingMatches = false;
        })
        .catch(function(error) {
          console.error('Erreur lors de la récupération des matchs à jouer:', error);
          self.loadingMatches = false;
        });
    },

    /**
     * Récupérer les matchs en live de la compétition
     */
    fetchLiveMatches: function fetchLiveMatches() {
      let self = this;
      this.loadingLiveMatches = true;

      // Récupérer la compétition depuis l'URL ou le contexte
      let competitionId = window.location.pathname.match(/\/competitions\/(\d+)/)?.[1];
      
      if (!competitionId) {
        this.loadingLiveMatches = false;
        return;
      }

      fetch(`/competitions/${competitionId}/live-matches`)
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          if (data.success) {
            self.liveMatches = data.matches;
            self.liveMatchesVisible = data.matches.length > 0;
          }
          self.loadingLiveMatches = false;
        })
        .catch(function(error) {
          console.error('Erreur lors de la récupération des matchs en live:', error);
          self.loadingLiveMatches = false;
        });
    },

    /**
     * Inviter un joueur à faire un match
     */
    inviteToMatch: function inviteToMatch(userId, matchId) {
      let self = this;

      // Récupérer les informations du match et de l'adversaire
      let opponent = null;
      if (this.usersWithMatches) {
        opponent = this.usersWithMatches.find(function(u) {
          return u.id === userId && u.match_id === matchId;
        });
      }

      if (!opponent) {
        console.error('Adversaire ou match introuvable');
        return;
      }

      // Envoyer l'invitation
      fetch('/notifications/invite-to-match', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          match_id: matchId,
          opponent_id: userId
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.success) {
          // Ouvrir la popup d'attente avec les données de l'adversaire
          self.matchInvitation = {
            show: true,
            waiting: true,
            opponent: opponent,
            matchId: matchId,
            timeRemaining: 0,
            status: 'waiting',
            message: 'En attente de réponse...',
            hasDelayProposal: false,
            proposedDelay: null
          };

          // Démarrer le polling
          self.startMatchInvitationPolling();
        } else {
          alert(data.message || 'Erreur lors de l\'envoi de l\'invitation');
        }
      })
      .catch(function(error) {
        console.error('Erreur lors de l\'invitation:', error);
        alert('Erreur lors de l\'envoi de l\'invitation');
      });
    },

    /**
     * Démarrer le polling pour vérifier le statut de l'invitation
     */
    startMatchInvitationPolling: function startMatchInvitationPolling() {
      let self = this;

      // Polling pour vérifier le statut
      this.matchInvitationCheckInterval = setInterval(function() {
        fetch('/notifications/check-match-invitation?match_id=' + self.matchInvitation.matchId)
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            if (data.success && data.status !== 'waiting') {
              self.closeMatchInvitationPolling();
              self.matchInvitation.status = data.status;
              self.matchInvitation.message = data.message;
              self.matchInvitation.waiting = false;

              if (data.status === 'accepted') {
                // Rediriger après 2 secondes
                setTimeout(function() {
                  window.location.href = '/matches/' + self.matchInvitation.matchId + '/live';
                }, 2000);
              } else if (data.status === 'delay_proposed') {
                // L'adversaire a proposé un délai
                self.matchInvitation.hasDelayProposal = true;
                self.matchInvitation.proposedDelay = data.message.match(/\d+/)[0]; // Extraire le nombre de minutes
              } else if (data.status === 'delay_waiting' && data.delay_info) {
                // Le délai a été accepté, démarrer le compteur
                self.matchInvitation.delayInfo = data.delay_info;
                self.matchInvitation.timeRemaining = data.delay_info.time_remaining;
                self.startDelayTimer();
              } else if (data.status === 'delay_expired') {
                // Le délai est expiré, rediriger
                setTimeout(function() {
                  window.location.href = '/matches/' + self.matchInvitation.matchId + '/live';
                }, 2000);
              }
            }
          })
          .catch(function(error) {
            console.error('Erreur lors de la vérification:', error);
          });
      }, 3000);
    },

    /**
     * Arrêter le polling
     */
    closeMatchInvitationPolling: function closeMatchInvitationPolling() {
      if (this.matchInvitationCheckInterval) {
        clearInterval(this.matchInvitationCheckInterval);
        this.matchInvitationCheckInterval = null;
      }
    },

    /**
     * Fermer la popup d'invitation
     */
    closeMatchInvitationPopup: function closeMatchInvitationPopup() {
      this.closeMatchInvitationPolling();
      this.matchInvitation.show = false;
    },

    /**
     * Accepter une invitation reçue
     */
    acceptMatchInvitation: function acceptMatchInvitation(matchId) {
      let self = this;

      fetch('/notifications/respond-to-match-invitation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          match_id: matchId,
          accept: true
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.success && data.redirect) {
          window.location.href = data.redirect;
        }
      })
      .catch(function(error) {
        console.error('Erreur lors de l\'acceptation:', error);
      });
    },

    /**
     * Proposer un délai
     */
    proposeDelay: function proposeDelay(matchId, delayMinutes) {
      let self = this;

      fetch('/notifications/respond-to-match-invitation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          match_id: matchId,
          propose_delay: delayMinutes
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.success) {
          // Fermer la popup
          self.pendingMatchInvitation.show = false;
          self.pendingMatchInvitation.showDelayChoice = false;
        }
      })
      .catch(function(error) {
        console.error('Erreur lors de la proposition de délai:', error);
      });
    },

    /**
     * Refuser une invitation reçue
     */
    refuseMatchInvitation: function refuseMatchInvitation(matchId) {
      let self = this;

      fetch('/notifications/respond-to-match-invitation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          match_id: matchId,
          accept: false
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.success) {
          // Fermer la popup
          self.pendingMatchInvitation.show = false;
        }
      })
      .catch(function(error) {
        console.error('Erreur lors du refus:', error);
      });
    },

    /**
     * Répondre à une proposition de délai
     */
    respondToDelayProposal: function respondToDelayProposal(matchId, accept) {
      let self = this;

      fetch('/notifications/respond-to-delay-proposal', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          match_id: matchId,
          accept: accept
        })
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.success) {
          self.matchInvitation.hasDelayProposal = false;
          if (accept && data.delay_info) {
            self.matchInvitation.message = 'Délai accepté. En attente...';
            self.matchInvitation.status = 'delay_accepted';
            self.matchInvitation.delayInfo = data.delay_info;
            self.matchInvitation.timeRemaining = data.delay_info.time_remaining;
            // Démarrer le compteur
            self.startDelayTimer();
          } else {
            self.matchInvitation.message = 'Délai refusé.';
            self.matchInvitation.status = 'delay_refused';
            self.matchInvitation.waiting = false;
          }
        }
      })
      .catch(function(error) {
        console.error('Erreur lors de la réponse au délai:', error);
      });
    },

    /**
     * Démarrer le timer du délai
     */
    startDelayTimer: function startDelayTimer() {
      let self = this;

      // Arrêter le timer existant s'il y en a un
      this.stopDelayTimer();

      // Démarrer un nouveau timer
      this.delayTimerInterval = setInterval(function() {
        if (self.matchInvitation.timeRemaining > 0) {
          self.matchInvitation.timeRemaining--;
        } else {
          // Temps écoulé
          self.stopDelayTimer();
          self.matchInvitation.message = 'Le délai est passé. Vous pouvez refaire une nouvelle demande.';
          self.matchInvitation.status = 'delay_expired';
          self.matchInvitation.delayInfo = null; // Masquer le compteur
          self.matchInvitation.waiting = false;

          // Rafraîchir les notifications pour mettre à jour l'état
          self.fetchNotifications();

          // Fermer la popup après 3 secondes
          setTimeout(function() {
            self.matchInvitation.show = false;
            self.pendingMatchInvitation.show = false;
          }, 3000);
        }
      }, 1000);
    },

    /**
     * Arrêter le timer du délai
     */
    stopDelayTimer: function stopDelayTimer() {
      if (this.delayTimerInterval) {
        clearInterval(this.delayTimerInterval);
        this.delayTimerInterval = null;
      }
    },

    /**
     * Formater le temps restant en heures:minutes:secondes ou minutes:secondes
     */
    formatTimeRemaining: function formatTimeRemaining(seconds) {
      let hours = Math.floor(seconds / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      let secs = seconds % 60;

      if (hours > 0) {
        return hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (secs < 10 ? '0' : '') + secs;
      }
      return minutes + ':' + (secs < 10 ? '0' : '') + secs;
    },

    /**
     * Formater l'heure d'expiration
     */
    formatExpirationTime: function formatExpirationTime(isoString) {
      if (!isoString) return '';
      let date = new Date(isoString);
      let hours = date.getHours();
      let minutes = date.getMinutes();
      return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    },


      toggleOpen : function(){
        this.statusOpen = !this.statusOpen;
      },

      changeStatus : function(event){
        // Empêcher la propagation de l'événement au parent
        if(event) {
            event.stopPropagation();
        }

        clearTimeout(this.changeStatuTimeout);

        if(this.userStatus == 'online'){
            this.userStatus = 'ready-to-play';
        }else if(this.userStatus == 'ready-to-play'){
            this.userStatus = 'offline';
        }else if(this.userStatus == 'offline'){
            this.userStatus = 'online';
        }

        let self = this;

          this.changeStatuTimeout = setTimeout(function(){
              self.updateStatus();
          }, 500);
      },

      updateStatus : function(){
        var status = this.userStatus;

        let self = this;
        fetch('/notifications/update-status', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
                status: status
            })
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            if (data.success) {
                console.log('Statut mis à jour avec succès');
            }
        })
        .catch(function(error) {
            console.error('Erreur lors de la mise à jour du statut:', error);
        });
      },

    /**
     * Récupérer les notifications depuis l'API
     */
    fetchNotifications: function fetchNotifications() {
      let self = this;
      this.loading = true;
      fetch('/notifications').then(function (response) {
        return response.json();
      }).then(function (data) {
        self.notifications = data.notifications || [];
        self.unreadCount = data.unread_count || 0;
        self.unreadUserNotificationsCount = data.unread_user_notification_count || 0;

        // Récupérer le statut et la dernière connexion de l'utilisateur
        self.userStatus = data.user_status || 'online';
        self.userName = data.user_name;
        self.lastLogin = data.last_login_at;

        // Récupérer les informations d'équipe si disponibles
        if (data.team_info) {
          self.teamInfo = data.team_info;
          // Compter les informations d'équipe non lues
          self.unreadTeamInfoCount = data.unread_team_info_count;
        }

          self.siteNotifications = data.siteNotifications || [];
          self.unreadSiteNotificationsCount = data.unread_site_notification_count || 0;

          // Vérifier s'il y a une invitation de match en attente
          if (data.pending_match_invitation) {
            self.pendingMatchInvitation = {
              show: true,
              opponent: data.pending_match_invitation.opponent_name,
              matchId: data.pending_match_invitation.match_id,
              opponentClub: data.pending_match_invitation.opponent_club,
              opponentLogo: data.pending_match_invitation.opponent_logo,
              championship: data.pending_match_invitation.championship,
              division: data.pending_match_invitation.division,
              group: data.pending_match_invitation.group,
              showDelayChoice: false,
              selectedDelay: 15,
              delayInfo: data.pending_match_invitation.delay_info || null
            };

            // Si le délai est accepté, démarrer le compteur
            if (data.pending_match_invitation.delay_status === 'accepted' && data.pending_match_invitation.delay_info) {
              self.matchInvitation.timeRemaining = data.pending_match_invitation.delay_info.time_remaining;
              self.pendingMatchInvitation.delayInfo = data.pending_match_invitation.delay_info;
              self.startDelayTimer();
            }
          }

          self.loading = false;
      })["catch"](function (error) {
        console.error('Erreur lors de la récupération des notifications:', error);
        self.loading = false;
      });
    },

    /**
     * Marquer une notification comme lue
     * @param {number} id - ID de la notification
     */
    markAsRead: function markAsRead(id) {
      let self = this;
      if (!id) return;
      var notification = this.notifications.find(function (n) {
        return n.id === id;
      });
      var hasLink = notification && notification.link;
      fetch("/notifications/".concat(id, "/read"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
          // Mettre à jour le statut de la notification dans la liste locale
          if (notification) {
            notification.read = true;
          }

          // Mettre à jour le compteur de notifications non lues
          self.unreadUnserNorificationsCount = data.unread_count;
          self.unreadCount = data.total_unread_count;

          // Rediriger vers le lien si présent
          /*if (hasLink) {
            window.location.href = notification.link;
          }*/
        }
      })["catch"](function (error) {
        console.error('Erreur lors du marquage de la notification comme lue:', error);
      });
    },
    /**
     * Marquer toutes les notifications comme lues
     */
    markAllAsRead: function markAllAsRead() {
      let self = this;
      fetch('/notifications/read-all', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
          // Mettre à jour le statut de toutes les notifications dans la liste locale
          self.notifications.forEach(function (notification) {
            notification.read = true;
          });

          // Mettre à jour le compteur de notifications non lues
          self.unreadUserNotificationsCount = 0;
          self.unreadCount = data.total_unread_count;

        }
      })["catch"](function (error) {
        console.error('Erreur lors du marquage de toutes les notifications comme lues:', error);
      });
    },
    /**
     * Marquer une information d'équipe comme lue
     * @param {number} id - ID de l'information d'équipe
     */
    markTeamInfoAsRead: function markTeamInfoAsRead(id) {
      let self = this;
      if (!id) return;
      fetch("/team-info/".concat(id, "/read"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
          // Mettre à jour le statut de l'information d'équipe dans la liste locale
          var info = self.teamInfo.find(function (i) {
            return i.id === id;
          });
          if (info) {
            info.read = true;
          }

          // Mettre à jour le compteur d'informations d'équipe non lues
          self.unreadTeamInfoCount = data.unread_count;
          self.unreadCount = data.total_unread_count;
        }
      })["catch"](function (error) {
        console.error("Erreur lors du marquage de l'information d'\xE9quipe comme lue:", error);
      });
    },
    /**
     * Marquer toutes les informations d'équipe comme lues
     */
    markAllTeamInfoAsRead: function markAllTeamInfoAsRead() {
      let self = this;
      fetch('/team-info/read-all', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
          // Mettre à jour le statut de toutes les informations d'équipe dans la liste locale
          self.teamInfo.forEach(function (info) {
            info.read = true;
          });

          // Mettre à jour le compteur d'informations d'équipe non lues
          self.unreadTeamInfoCount = 0;
          self.unreadCount = data.total_unread_count;
        }
      })["catch"](function (error) {
        console.error("Erreur lors du marquage de toutes les informations d'\xE9quipe comme lues:", error);
      });
    },

    /**
     * Marquer une notification de site comme lue
     * @param {number} id - ID de la notification de site
     */
    markSiteNotificationAsRead: function markSiteNotificationAsRead(id) {
      let self = this;
      if (!id) return;
      var notification = this.siteNotifications.find(function (n) {
        return n.id === id;
      });
      var hasLink = notification && notification.link;

      fetch("/site-notifications/".concat(id, "/read"), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
          // Mettre à jour le statut de la notification dans la liste locale
          if (notification) {
            notification.read = true;
          }

          // Mettre à jour le compteur de notifications non lues
          self.unreadSiteNotificationsCount = data.unread_count;
          self.unreadCount = data.total_unread_count;

          // Rediriger vers le lien si présent
          /*if (hasLink) {
            window.location.href = notification.link;
          }*/
        }
      })["catch"](function (error) {
        console.error('Erreur lors du marquage de la notification de site comme lue:', error);
      });
    },

    /**
     * Marquer toutes les notifications de site comme lues
     */
    markAllSiteNotificationsAsRead: function markAllSiteNotificationsAsRead() {
      let self = this;
      fetch('/site-notifications/read-all', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
            self.siteNotifications.forEach(function (notification) {
                notification.read = true;
            });

          // Mettre à jour le statut de toutes les notifications dans la liste locale
          self.unreadCount = data.total_unread_count;

          // Mettre à jour le compteur de notifications non lues
          self.unreadSiteNotificationsCount = 0;
        }
      })["catch"](function (error) {
        console.error('Erreur lors du marquage de toutes les notifications de site comme lues:', error);
      });
    },

    /**
     * Formater une date pour l'affichage
     * @param {string} dateString - Date au format ISO
     * @returns {string} - Date formatée
     */
    formatDate: function formatDate(dateString) {
      if (!dateString) return 'N/A';
      var date = new Date(dateString);
      var now = new Date();
      var diffMs = now - date;
      var diffMins = Math.floor(diffMs / 60000);
      var diffHours = Math.floor(diffMins / 60);
      var diffDays = Math.floor(diffHours / 24);

      // Si moins d'une minute
      if (diffMins < 1) {
        return 'À l\'instant';
      }

      // Si moins d'une heure
      if (diffMins < 60) {
        return "Il y a ".concat(diffMins, " minute").concat(diffMins > 1 ? 's' : '');
      }

      // Si moins d'un jour
      if (diffHours < 24) {
        return "Il y a ".concat(diffHours, " heure").concat(diffHours > 1 ? 's' : '');
      }

      // Si moins d'une semaine
      if (diffDays < 7) {
        return "Il y a ".concat(diffDays, " jour").concat(diffDays > 1 ? 's' : '');
      }

      // Sinon, afficher la date complète
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    /**
     * Obtenir le label de courtoisie (F, E, D, C, B, B+, A, A+, S, S+)
     */
    getCourtesyLabel: function(rating) {
      if (!rating) return 'B';
      
      const labels = {
        1: 'F',
        2: 'E',
        3: 'D',
        4: 'C',
        5: 'B',
        6: 'B+',
        7: 'A',
        8: 'A+',
        9: 'S',
        10: 'S+'
      };
      
      return labels[rating] || 'B';
    },
    
    /**
     * Vérifier si un utilisateur a des disponibilités
     */
    hasAvailability: function(user) {
      return user && user.availability && Object.keys(user.availability).length > 0;
    },
    
    /**
     * Formater les disponibilités d'un utilisateur pour l'affichage
     */
    formatAvailability: function(availability) {
      if (!availability) return [];
      
      const dayLabels = {
        'lundi': 'Lun',
        'mardi': 'Mar',
        'mercredi': 'Mer',
        'jeudi': 'Jeu',
        'vendredi': 'Ven',
        'samedi': 'Sam',
        'dimanche': 'Dim'
      };
      
      const timeLabels = {
        '10-12': '10h-12h',
        '12-14': '12h-14h',
        '14-16': '14h-16h',
        '16-18': '16h-18h',
        '18-20': '18h-20h',
        '20-22': '20h-22h',
        '22-00': '22h-00h'
      };
      
      const formatted = [];
      
      Object.keys(dayLabels).forEach(function(day) {
        if (availability[day]) {
          const slots = [];
          Object.keys(timeLabels).forEach(function(slot) {
            if (availability[day][slot]) {
              slots.push(timeLabels[slot]);
            }
          });
          
          if (slots.length > 0) {
            formatted.push({
              day: dayLabels[day],
              slots: slots.join(', ')
            });
          }
        }
      });
      
      return formatted;
    }
  };
};
